import { render, staticRenderFns } from "./HowtoStandardMember.vue?vue&type=template&id=f92a4984&scoped=true&"
import script from "./HowtoStandardMember.vue?vue&type=script&lang=js&"
export * from "./HowtoStandardMember.vue?vue&type=script&lang=js&"
import style0 from "./HowtoStandardMember.vue?vue&type=style&index=0&id=f92a4984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92a4984",
  null
  
)

export default component.exports